module.exports = __webpack_public_path__ + "img/basketball.be5030ca.webp";